module.exports = __webpack_public_path__ + "media/images/pic/lectors/agnieszka-zieba-8f36cccab01f6261cfa477517ff0a666.jpeg";